import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "../assets/css/OrderForm.css";

const deliveryOptions = ["Pickup", "Talabat", "Snoonu", "Rafeeq", "Keeta", "Deliveroo"];

function OrderForm() {
  const [selectedDelivery, setSelectedDelivery] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const { i18n } = useTranslation();
  const [success, setSuccess] = useState(false);
const { t } = useTranslation();

  useEffect(() => {
  axios.get("https://admin.kaakandtea.com/api/staffs")
    .then(res => {
      if (res.data && Array.isArray(res.data.data)) {
        setStaffs(res.data.data); 
      } else {
        setStaffs([]);
      }
    })
    .catch(err => {
      console.error(err);
      setStaffs([]);
    });
}, []);

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!selectedDelivery || !phoneNo || !selectedStaff) {
    alert("Please select delivery type, phone number, and staff.");
    return;
  }

  const payload = {
    delivery_type: selectedDelivery,
    order_no: orderNo,
    phone_no: phoneNo,
    staff_id: selectedStaff,
  };

  try {
    const response = await axios.post(
      "https://admin.kaakandtea.com/api/staff-thanks",
      payload
    );

    if (response.data.success) {
      setSuccess(true);
      // Optional: reset form
      setSelectedDelivery("");
      setOrderNo("");
      setPhoneNo("");
      setSelectedStaff("");
      setTimeout(() => {
    setSuccess(false);
    window.scrollTo({ top: 0, behavior: "smooth" }); // or navigate home
  }, 3000);
    } else {
      alert("Something went wrong. Please try again.");
    }
  } catch (error) {
    console.error(error);
    alert("Error submitting the form. Please try again later.");
  }
};


  return (
    <section className="order-form-section" id="next-section">
        {/* Success Popup */}
      {success && (
        <div className="success-popup">
          <p>{t('thankyou-message')}</p>
        </div>
      )}
      <form className="order-form" onSubmit={handleSubmit}>
        {/* Delivery Type */}
        <div className="form-group">
          <label>{t('delivery_type')}</label>
          <div className="delivery-options">
            {deliveryOptions.map(option => (
              <button
                type="button"
                key={option}
                className={selectedDelivery === option ? "delivery-btn active" : "delivery-btn"}
                onClick={() => setSelectedDelivery(option)}
              >
                {/* {option} */}
                {t(`delivery.${option}`)}
              </button>
            ))}
          </div>
        </div>

        {/* Order Number */}
        <div className="form-group">
          <label>{t('order_no')}</label>
          <input
            type="text"
            value={orderNo}
            onChange={(e) => setOrderNo(e.target.value)}
            placeholder="Enter order number"

          required
          />
        </div>

        {/* Phone Number */}
        <div className="form-group">
          <label>{t('phone_number')}</label>
          <input
            type="tel"
            value={phoneNo}
            onChange={(e) => setPhoneNo(e.target.value)}
            placeholder="Enter phone number"
            required
          />
        </div>

        {/* Staff Selection */}
        <div className="form-group">
          <label>{t('select_staff')}</label>
          </div>
        <div className="staff-grid">
  {staffs.length > 0 ? (
    staffs.map(staff => (
      <label key={staff.id} className="staff-card">
        <img 
          src={staff.image_url} 
          alt={i18n.language === "ar" ? staff.name_ar : staff.name_en} 
        />
        <div className="staff-name-radio">
          <input
            type="radio"
            name="staff"
            value={staff.id}
            checked={selectedStaff === staff.id}
            onChange={() => setSelectedStaff(staff.id)}
          />
          <span>{i18n.language === "ar" ? staff.name_ar : staff.name_en}</span>
        </div>
      </label>
    ))
  ) : (
    <p>No staff available at the moment.</p>
  )}
</div>



        <button type="submit" className="submit-btn">{t('submit')}</button>
      </form>
    </section>

    
  );
}

export default OrderForm;
